import { Card, Flex, Progress, Table, Tbody, Thead } from '@chakra-ui/react';
import {
  DEFAULT_BLUR_STYLES,
  useShowBlurOnScrollable,
} from '~/apps/consumer/hooks/useShowBlurOnScrollable';

interface BasicCardTableProps {
  loading: boolean;
  fetchTriggerRef: (ref: HTMLDivElement) => void;
  body: React.ReactNode;
  header: React.ReactNode;
}

export const BasicCardTable = ({
  loading,
  fetchTriggerRef,
  header,
  body,
}: BasicCardTableProps) => {
  const { showBlur, setInitialBlurRef, handleBlurOnScroll } =
    useShowBlurOnScrollable();

  return (
    <Card
      _after={{
        display: showBlur ? 'block' : 'none',
        ...DEFAULT_BLUR_STYLES,
        minHeight: '100px',
        background:
          'linear-gradient(0deg, #161632 0%, rgba(22, 22, 50, 0.00) 100%)',
      }}
      display="flex"
      flexDirection="column"
      height="100%"
      minHeight="500px"
      overflow="hidden"
    >
      <Progress
        isIndeterminate
        height="2px"
        size="xs"
        visibility={loading ? 'visible' : 'hidden'}
        width="100%"
      />
      <Flex
        ref={setInitialBlurRef}
        direction="column"
        flex={1}
        minHeight={0}
        overflow="auto"
        overscrollBehavior="contain"
        width="100%"
        onScroll={handleBlurOnScroll}
      >
        <Table size={{ base: 'sm', md: 'md' }}>
          <Thead bg="indigo.700" position="sticky" top={0} zIndex={1}>
            {header}
          </Thead>
          <Tbody>
            {body}
            {fetchTriggerRef && <div ref={fetchTriggerRef} />}
          </Tbody>
        </Table>
      </Flex>
    </Card>
  );
};
